export default __webpack_public_path__ + "static/aatmanirbhar-bharat-logo-e0f148cb347681d1825cf22babd73516.png";